/* eslint-disable no-nested-ternary */
import React, { useState } from "react";

import { FaRegStar } from "react-icons/fa";
import { useGetDestaques } from "services/api/Destaques/get-destaques";
import { CiCalendar } from "react-icons/ci";
import { MdGrain } from "react-icons/md";
import * as S from "./styles";
import MaterialUI from "../../../../material-UI";

// Tipos
type Ranking = {
  posicao: number;
  equipe: string;
  apelido: string;
  pontuacao: number;
  urlFoto: string;
};

type Regional = {
  idRanking: number;
  titulo: string;
  numeroMembros: number; // string usada para mapear o gradiente
  pontuacaoMedia: number;
  tipoVisualizacao: string;
  urlFotoBandeira: string;
  dataAtualizacao: string;
  corDestaque: string;
  usuarios: Ranking[];
};

function DestaquesContent() {
  const { data, isLoading: isLoadingDestaques } = useGetDestaques({
    quantidadeUsuariosPorDestaque: 3,
  });
  // Exemplo de dados

  return (
    <S.Content>
      <S.Container>
        {/* Header: Título "Destaques" + ícone de estrela */}
        <S.Header>
          <S.HeaderTitle>Destaques</S.HeaderTitle>
          <FaRegStar color="#1A49CC" size={24} />
        </S.Header>

        {/* Grid de Regionais */}
        {isLoadingDestaques ? (
          <div
            style={{
              display: "flex",
              marginTop: "16px",
              justifyContent: "center",
              marginBottom: "24px",
            }}
          >
            <MaterialUI.CircularProgress style={{ color: "blue" }} size={36} />
          </div>
        ) : data?.destaques?.length > 0 ? (
          <S.RegionalsGrid>
            {data?.destaques?.map((item: Regional) => {
              return (
                <S.RegionalCard key={item.idRanking}>
                  {/* Cabeçalho com gradiente dinâmico */}
                  <S.RegionalCardHeader>
                    <S.RegionalIcon>
                      <S.RegionalBandeiraImg
                        src={item?.urlFotoBandeira}
                        alt="bandeira"
                      />
                    </S.RegionalIcon>
                    <S.RegionalInfos>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <CiCalendar color="#646363" />
                        <S.RegionalTextInfo>
                          Atualizado em {item?.dataAtualizacao}
                        </S.RegionalTextInfo>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <MdGrain color="#646363" />
                        <S.RegionalTextInfo>
                          {item?.tipoVisualizacao}
                        </S.RegionalTextInfo>
                      </div>
                    </S.RegionalInfos>
                  </S.RegionalCardHeader>

                  {/* Linha divisoria */}
                  <S.RegionalLine corDestaque={item?.corDestaque} />

                  {/* Top 3 */}
                  <S.RegionalCardBody>
                    {item.usuarios.slice(0, 3).map((rank) => (
                      <S.Top3Item key={rank.posicao}>
                        <S.Avatar src={rank.urlFoto} alt={rank.apelido} />
                        <S.RankInfo>
                          <p>{rank.apelido}</p>
                          <span>{rank.equipe}</span>
                        </S.RankInfo>
                        <S.PointsInfo>{rank.pontuacao}</S.PointsInfo>
                      </S.Top3Item>
                    ))}
                  </S.RegionalCardBody>
                </S.RegionalCard>
              );
            })}
          </S.RegionalsGrid>
        ) : (
          <div
            style={{
              display: "flex",
              marginTop: "16px",
              justifyContent: "center",
              marginBottom: "24px",
            }}
          >
            <S.HeaderTitle>Nenhum destaque encontrado</S.HeaderTitle>
          </div>
        )}

        {/* Botão fixo ao final (via position: sticky) */}
        <S.BottomButtonWrapper>
          <S.BottomButton href="/destaques">
            Veja relação completa &gt;
          </S.BottomButton>
        </S.BottomButtonWrapper>
      </S.Container>
    </S.Content>
  );
}

export default DestaquesContent;
